import { useMemo } from 'react'

import { useSubjectSelector } from '@procom-labs/common'

import { servicePlanStore, userOrganizationStore } from '@resume-portal/stores'

import { PricingPlans } from '../models'

export type UseRemainingTrialDaysHookType = {
  remainingTrialDays: number | null
}

export const useRemainingTrialDays = (): UseRemainingTrialDaysHookType => {
  const { userOrganization } = useSubjectSelector(userOrganizationStore, [
    'userOrganization',
  ])
  const { servicePlans } = useSubjectSelector(servicePlanStore, [
    'servicePlans',
  ])

  const remainingTrialDays = useMemo(() => {
    if (!userOrganization || !servicePlans) return null

    const freeTrialServicePlan = servicePlans.find(
      (plan) => plan.code === PricingPlans.FreeTrial
    )
    if (
      freeTrialServicePlan &&
      userOrganization?.servicePlanId &&
      userOrganization?.servicePlanId !== freeTrialServicePlan.id
    )
      return null
    const createdDateTime = new Date(userOrganization.createdDateTime)
    const currentDate = new Date()

    const elapsedTime = Math.max(
      Math.floor(
        (currentDate.getTime() - createdDateTime.getTime()) /
          (1000 * 60 * 60 * 24)
      ),
      0
    )
    const remainingDays = (freeTrialServicePlan?.daysLimit ?? 0) - elapsedTime

    return Math.max(remainingDays, 0)
  }, [userOrganization, servicePlans])

  return {
    remainingTrialDays,
  }
}
